import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const CancellationRefunds = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  const sections = [
    {
      id: "order-cancellation",
      title: "1. Order Cancellation Policy",
      content: [
        {
          items: [
            "Orders can be canceled only before the order is confirmed and processed by our delivery partners.",
            "Once the order is in 'Confirmed' or 'Processing' status, cancellation may not be possible.",
            "Cancellation requests must be made through the app or customer support.",
          ],
        },
      ],
    },
    {
      id: "refund-process",
      title: "2. Refund Process",
      content: [
        {
          items: [
            "Refunds are processed for eligible orders within 5-7 business days.",
            "Refund amount will be credited to the original payment method used during the order.",
            "Partial refunds may be applicable based on the reason for return.",
          ],
        },
      ],
    },
    {
      id: "return-conditions",
      title: "3. Return Conditions",
      content: [
        {
          items: [
            "Items can be returned within 24 hours of delivery for the following reasons:",
            "- Damaged or defective product",
            "- Incorrect or incomplete order",
            "- Product differs significantly from description",
            "Perishable items, personal care products, and intimate wear are non-returnable.",
          ],
        },
      ],
    },
    {
      id: "refund-eligibility",
      title: "4. Refund Eligibility",
      content: [
        {
          items: [
            "Full refund is provided for:",
            "- Damaged products",
            "- Incorrect items delivered",
            "- Significant discrepancies in product description",
            "Partial refunds or store credits may be issued for other return scenarios.",
          ],
        },
      ],
    },
    {
      id: "return-procedure",
      title: "5. Return Procedure",
      content: [
        {
          items: [
            "Initiate return through the 'Orders' section in the TezChal app.",
            "Provide reason for return and upload supporting images if required.",
            "Our team will review and approve the return request.",
            "Once approved, generate a return shipping label or schedule pickup.",
          ],
        },
      ],
    },
    {
      id: "refund-methods",
      title: "6. Refund Methods",
      content: [
        {
          items: [
            "Refunds will be processed to the original payment method.",
            "If original payment method is unavailable, store credit will be issued.",
            "Bank transfers may take 5-10 business days to reflect.",
            "Digital wallet refunds are processed instantly.",
          ],
        },
      ],
    },
  ];

  return (
    <>
      <Navbar />
      <div className="max-w-4xl mx-auto p-4 space-y-6">
        {/* Header */}
        <div className="text-center mb-8 relative">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500" />
          <h1 className="text-3xl font-bold mb-2 pt-4">
            Cancellation & Refunds
          </h1>
          {/* <p className="text-gray-600">Effective Date: [Insert Date]</p> */}
        </div>

        {/* Welcome Banner */}
        <div className="bg-white rounded-lg shadow-md mb-6 border-l-4 border-blue-500">
          <div className="p-6">
            <p className="text-lg">
              At <span className="font-bold">TezChal</span>, we strive to ensure
              your complete satisfaction. Our Cancellation and Refund Policy is
              designed to provide transparent and fair solutions for our valued
              customers.
            </p>
          </div>
        </div>

        {/* Collapsible Sections */}
        {sections.map((section) => (
          <div
            key={section.id}
            className="bg-white rounded-lg shadow-md mb-4 transition-all duration-200 hover:shadow-lg"
          >
            <div
              className="p-4 flex justify-between items-center cursor-pointer hover:bg-gray-50 rounded-t-lg"
              onClick={() => toggleSection(section.id)}
            >
              <div className="flex items-center">
                {section.icon}
                <h2 className="lg:text-xl xsm:text-[16.5px] font-semibold">
                  {section.title}
                </h2>
              </div>
              {expandedSections[section.id] ? (
                <ChevronUp className="w-6 h-6 text-gray-500" />
              ) : (
                <ChevronDown className="w-6 h-6 text-gray-500" />
              )}
            </div>

            {expandedSections[section.id] && (
              <div className="p-4 pt-0 border-t border-gray-100">
                {section.content.map((contentBlock, idx) => (
                  <div key={idx} className="mb-4">
                    <ul className="space-y-3">
                      {contentBlock.items.map((item, itemIdx) => (
                        <li
                          key={itemIdx}
                          className="text-gray-700 flex items-start"
                        >
                          <span className="mr-2 mt-1">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        {/* Contact Section */}
        <div className="bg-white rounded-lg shadow-md mt-8">
          <div className="p-6">
            <h2 className="text-xl font-semibold mb-4">Need Help?</h2>
            <p className="mb-4">
              If you have any questions about our Cancellation and Refund
              Policy, please contact our customer support.
            </p>
            <div className="space-y-2">
              <p className="font-bold">TezChal Customer Support</p>
              <p>
                Apartment Sandeep Vihar, Block/Tower G-25, <br />
                Floor No. 13 and 14, Kannamangala Village <br />
                Bidarahalli, Bengaluru East Taluk, Karnataka-560067
              </p>
              <p>info@tezchal.com</p>
              <p>+91 8981440034</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CancellationRefunds;
